import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { distinctUntilChanged, filter, map, mapTo, share, skip } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { BroadcastEventsService, MetaService } from '@core/services';
import { CloseAsidePageEvent, EAsideOutlets, IRouteData } from '@project/shared';
import { AppInitializerService } from './app.component.service';
import { HcService } from '@project/services';
import { SupportChatService } from './project/services/support-chat.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {
  private routeChanges$: Observable<ActivatedRoute>;

  public readonly asideOutlets = EAsideOutlets;

  constructor(
    private appInitializerService: AppInitializerService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private metaService: MetaService,
    private broadcastEventsService: BroadcastEventsService,
    private supportChatService: SupportChatService,

    private hcService: HcService,
  ) {}

  public ngOnInit(): void {
    this.appInitializerService.initialize();

    this.metaService.setMetaTags();

    this.initializePreloader();

    this.routeChanges$ = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      mapTo(this.activatedRoute),
      map((route) => {
        while (route?.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      filter((route) => !!route?.snapshot?.data),
      share(),
    );

    this.initTitleRefresh();
    this.closeAsideOutletsOnPrimaryRouteChange();
  }

  ngAfterViewInit(): void {
    this.supportChatService.loadSupportChat();
  }

  private initializePreloader(): void {
    const preloader = document.getElementById('preloader');
    const preloaderImage = document.getElementById('preloader-image');

    if (!preloader || !preloaderImage) {
      return;
    }
    const imageUrl = this.hcService.getHcConfig().assets.preloaderLogo;
    preloaderImage.style.backgroundImage = `url("${imageUrl}")`;

    setTimeout(() => {
      preloader.style.display = 'none';
    }, 1000);
  }

  private initTitleRefresh() {
    this.routeChanges$
      .pipe(
        filter((route) => route.outlet === 'primary'),
        map((route) => {
          while (route && !route?.snapshot?.data?.titleCreator) {
            route = route.parent;
          }
          return route?.snapshot.data || {};
        }),
        distinctUntilChanged(),
      )
      .subscribe(({ titleCreator }: IRouteData) => {
        const title = this.hcService.getHcConfig().appName;

        this.metaService.setTitle(titleCreator ? titleCreator() : title);
      });
  }

  private closeAsideOutletsOnPrimaryRouteChange() {
    this.routeChanges$
      .pipe(
        filter((route) => route.outlet === 'primary'),
        distinctUntilChanged(),
        skip(1), // skip initial route navigation when user can open outlet page from bookmarks
      )
      .subscribe(() => {
        this.broadcastEventsService.broadcast(new CloseAsidePageEvent());
      });
  }
}
